var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonUserFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 21.0943V24.8125H5.5625V21.094C5.56421 19.6607 6.13437 18.2865 7.14793 17.2729C8.16148 16.2594 9.53567 15.6892 10.969 15.6875H16.031C17.4643 15.6892 18.8385 16.2594 19.8521 17.2729C20.8657 18.2865 21.4359 19.6608 21.4375 21.0943Z",
    stroke: "#2E3E4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00487 10.5973C8.41082 9.70825 8.09375 8.66301 8.09375 7.59375C8.09375 6.15992 8.66334 4.78482 9.6772 3.77095C10.6911 2.75709 12.0662 2.1875 13.5 2.1875C14.5693 2.1875 15.6145 2.50457 16.5036 3.09862C17.3926 3.69266 18.0855 4.537 18.4947 5.52487C18.9039 6.51273 19.011 7.59975 18.8024 8.64846C18.5938 9.69717 18.0789 10.6605 17.3228 11.4165C16.5667 12.1726 15.6034 12.6875 14.5547 12.8961C13.506 13.1047 12.419 12.9977 11.4311 12.5885C10.4433 12.1793 9.59891 11.4864 9.00487 10.5973Z",
    stroke: "#2E3E4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonUserFilled);
export default __webpack_public_path__ + "static/media/carbon_user-filled.ba384f64.svg";
export { ForwardRef as ReactComponent };